import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MasterService } from '../../services/master.service';
import { GlobalService } from '../../services/global.service';
import { takeUntil } from 'rxjs/operators';
import { UserInfoInterface } from 'src/app/hotel-admin/components/messaging/messaging.component';
import { RestaurantOrderService } from '../../services/restaurant-order.service';
import { JwtService } from '../../services/jwt.service';
import jwt_decode from 'jwt-decode';
import { PrintRestaurantOrderComponent } from '../../modals/print-restaurant-order/print-restaurant-order.component';
import { ItemCommentComponent } from '../../modals/item-comment/item-comment.component';
import { RestaurantInvoiceComponent } from '../restaurant-invoice/restaurant-invoice.component';
import { MatDialog } from '@angular/material/dialog';
import { Globals } from '../../globals';
import { ManageBrandingModel } from '../../models/request/manageBranding.model';
import { RestaurantInvoicePrintComponent } from '../restaurant-invoice-print/restaurant-invoice-print.component';
import { RestaurantSettleBillDialogComponent } from '../../modals/restaurant-settle-bill-dialog/restaurant-settle-bill-dialog.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-restro-order-history-admin',
  templateUrl: './restro-order-history-admin.component.html',
  styleUrls: ['./restro-order-history-admin.component.scss']
})
export class RestroOrderHistoryAdminComponent implements OnInit {
  @Output() toggleOrders: EventEmitter<void> = new EventEmitter<void>(); 
  @Input() orderId: string | null = null;
  @Input() isInclusive: boolean = false;
  @Input() restaurantOrderMode: boolean = false;
  @Input() restaurantId: string = '';
  displayedColumns: string[] = ['position', 'name', 'weight', 'symbol', 'itemComment'];
  dataSource = ELEMENT_DATA;
  groupedDataSource: { categoryName: string; items: PeriodicElement[] }[] = [];
  isEditingGuestName = false;
  guestNameDraft = '';
  brandingSubscribe$;
  dataSource2
  currencyLogo
  orderDetails
  requestId
  currencyAbri
  public toggle = true;
  tax
  location
  RestaurantOrder
  priceWithoutTax;
  formattedTaxRates
  inclusiveDisplayAmount: number | null = null;
  readonly restaurantOrderTipOptions = [5, 10, 15, 20];
  isUpdatingTip = false;
  showCustomTip = false;
  customTipAmount: string | number = '';
  tipErrorMessage = '';
  private activeTipUpdateIsCustom = false;
  private queuedTipUpdate: { tip: number; isCustomTip: boolean } | null = null;
  public isRestaurantOrderDetailLoading: boolean = false;
  public isSavingStaffComment: boolean = false;
  public loggedInUserInfo: UserInfoInterface;
  public manageBrandingModel: ManageBrandingModel = new ManageBrandingModel();
  BookingUserId
  UserId
  logo
  address;
  public filterDate: { fromDate: any; toDate: any; };

  displayedColumnss = ['item', 'cost'];
  transactions: Transaction[] = [
    // {item: 'Beach ball', cost: 4},
    // {item: 'Towel', cost: 5},
    // {item: 'Frisbee', cost: 2},
    // {item: 'Sunscreen', cost: 4},
    // {item: 'Cooler', cost: 25},
    // {item: 'Swim suit', cost: 15},
  ];

  panelOpenState = false;

  get staffName(): string {
    if (!this.restaurantOrderMode) {
      return '';
    }
    const createdByName = this.orderDetails?.CreatedByName;
    return typeof createdByName === 'string' ? createdByName.trim() : '';
  }

  constructor( public masterService: MasterService,
    private dialog: MatDialog,
    public globals: Globals,
    public globalService: GlobalService,
    private jwtService: JwtService,
    private restaurantOrderService: RestaurantOrderService,
    private translate: TranslateService,
    ) { 
      this.loggedInUserInfo = jwt_decode(this.jwtService.getToken());
    }

  ngOnInit(): void {
    this.filterDate = JSON.parse(localStorage.getItem('viewOrderFilterData'));
   
    this.requestId = this.orderId;
    this.fetchManageBranding()
    this.fetchOrderDetail()
    this.getHotelsName();
    this.OrderHistory();
  }
  getHotelsName() {
    
    const data = {
    };
    this.masterService.getHotelName(data).subscribe((response) => {
      if (response) {
       
        window.localStorage['CurrencyLogo'] = response[0].symbol;
        window.localStorage['CurrencyAbri'] = response[0].abbreviation;
        window.localStorage['Currency'] = response[0].currency;
        this.currencyLogo = response[0].symbol;
        this.currencyAbri = response[0].abbreviation;
        this.globalService.setHotelNameUpdate(response[1]);
      }
      (error) => {
        this.globalService.handleApiError(error);
      };
    });
  } 
  
  printOrder(id,viewOrder){
    
    let dialogRef = this.dialog.open(PrintRestaurantOrderComponent, {
      width: "550px",
      disableClose: true,
      data: {
        viewOrder: viewOrder,
        requestId:id,
      }
    });
  }
  fetchManageBranding() {
      this.masterService.getManageBranding({
        Lang: this.globals.hotelLangTranslate,
        Subdomain: this.globalService.getHostname()
      });
      //Subscribe to Branding
      this.brandingSubscribe$ = this.masterService.manageBrandingData.subscribe(
        response => {
          if (response.Data) {
            //
            this.manageBrandingModel = this.globalService.jsonConvert.deserializeObject(
              response.Data,
              ManageBrandingModel
            );
            this.logo = this.manageBrandingModel.Logo;
              if(response?.Data?.Address){
          this.address=response?.Data?.Address[0];
          }     
            // 
          } else {
            this.globalService.handleApiError(response.error);
          }
        },
        error => {
          this.globalService.showLoader = false;
          this.globalService.handleApiError(error);
        }
      );
    }

  fetchOrderDetail(){
    this.isRestaurantOrderDetailLoading = this.restaurantOrderMode;
    const orderDetailRequest = this.restaurantOrderMode
      ? this.restaurantOrderService.getOrder({
          ResturantId: this.restaurantId,
          requestId: this.requestId,
        })
      : this.masterService.getRestaurantOrderDetail({requestId : this.requestId});

    orderDetailRequest
      .pipe(takeUntil(this.globalService.componentDestroyed(this)))
      .subscribe(
        response => {
          if(response.Status){
            const orderDetails = Array.isArray(response.Data)
              ? response.Data[0]
              : response.Data;
            if (!orderDetails) {
              this.isRestaurantOrderDetailLoading = false;
              this.globalService.handleApiError(response);
              return;
            }
            this.orderDetails = orderDetails;
            if (this.restaurantOrderMode) {
              this.isInclusive =
                this.isInclusive || this.isStrictInclusiveOrder(orderDetails);
            }
                    const parsedInclusiveAmount = Number(this.orderDetails?.InclusiveDisplayAmount);
            this.inclusiveDisplayAmount = !isNaN(parsedInclusiveAmount) ? parsedInclusiveAmount : null;
            this.BookingUserId = this.orderDetails.BookingUserId;
            this.UserId = this.orderDetails.UserId;

            const built = this.buildLineItemsFromOrder(orderDetails);
            const dataSourcePrint = built.lines;
            this.tax = built.totalRestroTax ? built.totalRestroTax : 0;
            this.priceWithoutTax = this.orderDetails?.TotalPrice - this.tax;
            this.formattedTaxRates = this.formatTaxRates(built.uniqueTaxRates);

            if (this.restaurantOrderMode) {
              this.RestaurantOrder = [];
              this.dataSource2 = [];
            } else {
              this.fetchRestaurantOrder();
            }

            this.dataSource = dataSourcePrint.slice(0);

            if (this.isInclusive) {
              const grouped: { categoryName: string; items: PeriodicElement[] }[] = [];
              for (const menuCategory of orderDetails.ResturantItemName || []) {
                const categoryName =
                  menuCategory.ResturantCatogoriesNameLang?.[0]?.Value || 'Uncategorized';
                const categoryItems = dataSourcePrint.filter(
                  (line) => line.categoryName === categoryName
                );
                if (categoryItems.length > 0) {
                  grouped.push({ categoryName, items: categoryItems });
                }
              }
              this.groupedDataSource = grouped;
            } else {
              this.groupedDataSource = [];
            }
            this.isRestaurantOrderDetailLoading = false;
              
          }
          else {
            this.isRestaurantOrderDetailLoading = false;
            this.globalService.showLoader = false;
          }
        },
        error => {
          this.isRestaurantOrderDetailLoading = false;
          this.globalService.showLoader = false;
          this.globalService.handleApiError(error);
        }
      );
  }

  collectItemCommentRows(): PeriodicElement[] {
    if (this.isInclusive && this.groupedDataSource?.length) {
      return ([] as PeriodicElement[]).concat(
        ...this.groupedDataSource.map((g) => g.items || [])
      );
    }
    return (this.dataSource as PeriodicElement[]) || [];
  }

  private isRestaurantOrder(): boolean {
    return (
      this.orderDetails?.PaymentCollectionMethod === 'pay with waiter' &&
      this.orderDetails?.OrderSource === 'waiter'
    );
  }

  private get isOpenRestaurantBill(): boolean {
    return (
      this.restaurantOrderMode &&
      !!this.orderDetails &&
      !this.isInclusive &&
      Number(this.orderDetails.Status) !== 5 &&
      this.isRestaurantOrder() &&
      (this.orderDetails.InclusiveWeekKey === null ||
        this.orderDetails.InclusiveWeekKey === undefined)
    );
  }

  get canAddItems(): boolean {
    return (
      this.isOpenRestaurantBill &&
      Number(this.orderDetails.PaymentStatus) === 2 &&
      !this.hasActiveBillSplit
    );
  }

  get orderTip(): number {
    return Number(this.orderDetails?.tip || 0);
  }

  get orderTotalDue(): number {
    return Number(this.orderDetails?.TotalPrice || 0) + this.orderTip;
  }

  get canEditTip(): boolean {
    return this.canAddItems;
  }

  addMoreItems(): void {
    this.restaurantOrderService.start({
      restaurantId: this.restaurantId,
      inclusiveMode: false,
      tableNumber: this.orderDetails?.tableNumber,
      appendToOrderId: String(this.orderDetails?._id || this.requestId || ''),
    });
  }

  selectTip(amount: number): void {
    this.showCustomTip = false;
    this.customTipAmount = '';
    this.updateTip(this.orderTip === amount ? 0 : amount);
  }

  openCustomTip(): void {
    this.showCustomTip = true;
    this.tipErrorMessage = '';
    this.customTipAmount = this.customTipSelected ? this.orderTip.toFixed(2) : '';
  }

  applyCustomTip(): void {
    if (!this.canApplyCustomTip) {
      this.tipErrorMessage = this.translate.instant('restaurantOrderActions.invalidTip');
      return;
    }
    this.updateTip(Number(this.customTipAmount), true);
  }

  private isValidTip(amount: number): boolean {
    return (
      Number.isFinite(amount) &&
      amount >= 0 &&
      Number.isSafeInteger(Math.round(amount * 100)) &&
      Math.abs(amount * 100 - Math.round(amount * 100)) < 0.000001
    );
  }

  private updateTip(tip: number, isCustomTip: boolean = false): void {
    if (!this.canEditTip) {
      return;
    }
    if (this.isUpdatingTip) {
      this.orderDetails.tip = tip;
      this.queuedTipUpdate = { tip, isCustomTip };
      this.tipErrorMessage = '';
      return;
    }
    if (tip === this.orderTip) {
      this.showCustomTip = false;
      this.customTipAmount = '';
      return;
    }

    const previousTip = this.orderTip;
    this.orderDetails.tip = tip;
    this.isUpdatingTip = true;
    this.activeTipUpdateIsCustom = isCustomTip;
    this.tipErrorMessage = '';
    this.restaurantOrderService
      .updateTip({
        ResturantId: this.restaurantId,
        requestId: this.requestId,
        tip,
      })
      .subscribe(
        (response: any) => {
          if (!response?.Status) {
            this.onTipUpdateFailed(previousTip, response?.Message);
            return;
          }
          this.isUpdatingTip = false;
          this.activeTipUpdateIsCustom = false;
          this.orderDetails.tip = Number(response.Data?.tip || 0);
          this.orderDetails.BillVersion = String(response.Data.BillVersion);
          this.orderDetails.BillTotals = response.Data.BillTotals;
          this.orderDetails.BillSplitSummary = null;
          this.showCustomTip = false;
          this.customTipAmount = '';
          this.flushQueuedTip(this.orderTip);
        },
        (error) => this.onTipUpdateFailed(previousTip, error?.error?.Message || error?.Message)
      );
  }

  private onTipUpdateFailed(previousTip: number, message: string): void {
    this.isUpdatingTip = false;
    this.activeTipUpdateIsCustom = false;
    this.orderDetails.tip = previousTip;
    this.tipErrorMessage = message || this.translate.instant('restaurantOrderActions.invalidTip');
    this.flushQueuedTip(previousTip);
  }

  private flushQueuedTip(currentTip: number): void {
    const queuedUpdate = this.queuedTipUpdate;
    this.queuedTipUpdate = null;
    if (queuedUpdate && queuedUpdate.tip !== currentTip) {
      this.updateTip(queuedUpdate.tip, queuedUpdate.isCustomTip);
    }
  }

  onCustomTipChange(value: string | number): void {
    this.customTipAmount = value;
    this.tipErrorMessage = '';
  }

  cancelCustomTip(): void {
    const shouldRemoveCustomTip =
      this.customTipSelected ||
      this.activeTipUpdateIsCustom ||
      this.queuedTipUpdate?.isCustomTip === true;
    this.showCustomTip = false;
    this.customTipAmount = '';
    this.tipErrorMessage = '';
    if (shouldRemoveCustomTip) {
      this.updateTip(0);
    }
  }

  get customTipSelected(): boolean {
    return this.orderTip > 0 && !this.restaurantOrderTipOptions.includes(this.orderTip);
  }

  get canApplyCustomTip(): boolean {
    return (
      String(this.customTipAmount).trim() !== '' &&
      this.isValidTip(Number(this.customTipAmount))
    );
  }

  get canUpdateOrderPaymentStatus(): boolean {
    const paymentStatus = Number(this.orderDetails?.PaymentStatus);
    return this.isOpenRestaurantBill && (paymentStatus === 1 || paymentStatus === 2);
  }

  get isOrderPaid(): boolean {
    return Number(this.orderDetails?.PaymentStatus) === 1;
  }

  get hasActiveBillSplit(): boolean {
    return !!this.orderDetails?.BillSplitSummary;
  }

  get settleBillButtonLabel(): string {
    return this.hasActiveBillSplit ? 'restaurantSplitBill.collectPayments' : 'restaurantSplitBill.settleBill';
  }

  openSettleBillDialog(): void {
    if (!this.canUpdateOrderPaymentStatus || this.isUpdatingTip) {
      return;
    }

    const dialogRef = this.dialog.open(RestaurantSettleBillDialogComponent, {
      width: '550px',
      maxWidth: 'calc(100vw - 32px)',
      maxHeight: 'calc(100vh - 32px)',
      panelClass: 'cm-md-modal',
      autoFocus: false,
      data: {
        restaurantId: this.restaurantId,
        orderId: this.requestId,
        tableNumber: String(this.orderDetails?.tableNumber || ''),
        guestName: String(this.orderDetails?.guestName || ''),
        orderVersion: String(this.orderDetails?.BillVersion || ''),
        totals: this.orderDetails?.BillTotals,
        currencyLabel: this.currencyLogo || this.currencyAbri || '',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.completed) {
        this.toggleOrders.emit();
      } else {
        this.fetchOrderDetail();
      }
    });
  }

  @ViewChild('guestNameInput') set guestNameInput(input: ElementRef<HTMLInputElement> | undefined) {
    if (!input) {
      return;
    }

    const element = input.nativeElement;
    element.focus();
    element.setSelectionRange(element.value.length, element.value.length);
  }

  get canEditGuestName(): boolean {
    return this.restaurantOrderMode && this.canEditItemComment;
  }

  startEditGuestName(): void {
    if (!this.canEditGuestName) {
      return;
    }
    this.guestNameDraft = this.orderDetails?.guestName || '';
    this.isEditingGuestName = true;
  }

  cancelEditGuestName(): void {
    this.isEditingGuestName = false;
  }

  saveGuestName(): void {
    if (!this.isEditingGuestName) {
      return;
    }
    this.isEditingGuestName = false;

    const guestName = this.guestNameDraft.trim();
    if (guestName === (this.orderDetails?.guestName || '')) {
      return;
    }

    this.restaurantOrderService
      .updateGuestName({
        ResturantId: this.restaurantId,
        requestId: this.requestId,
        guestName,
      })
      .pipe(takeUntil(this.globalService.componentDestroyed(this)))
      .subscribe(
        (response) => {
          if (!response?.Status) {
            this.globalService.handleApiError(response);
            return;
          }
          this.orderDetails.guestName = guestName;
        },
        (error) => this.globalService.handleApiError(error)
      );
  }

  openItemComment(row: PeriodicElement): void {
    const dialogRef = this.dialog.open(ItemCommentComponent, {
      width: '460px',
      panelClass: 'cm-md-modal',
      data: {
        itemName: row.Itemname,
        comment: row.staffMealComment || '',
        readOnly: !this.canEditItemComment,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result?.saved) {
        return;
      }

      const previous = row.staffMealComment || '';
      row.staffMealComment = result.comment;
      this.saveItemStaffMealComments(() => {
        row.staffMealComment = previous;
      });
    });
  }

  get canEditItemComment(): boolean {
    if (!this.restaurantOrderMode) {
      return true;
    }
    return Number(this.orderDetails?.PaymentStatus) === 2 && Number(this.orderDetails?.Status) !== 5;
  }

  saveItemStaffMealComments(onFailure: () => void) {
    if (!this.requestId || this.isSavingStaffComment) {
      onFailure();
      return;
    }

    const rows = this.collectItemCommentRows();
    if (!rows.length) {
      onFailure();
      return;
    }

    for (const row of rows) {
      if ((row.staffMealComment || '').length > 500) {
        this.globalService.handleErrorMessage('Each item comment must be 500 characters or less');
        onFailure();
        return;
      }
    }

    const itemComments = rows.map((r) => ({
      index: r.itemIndex,
      comment: (r.staffMealComment || '').trim(),
    }));

    this.isSavingStaffComment = true;
    this.masterService
      .updateRestaurantOrderComment({
        requestId: this.requestId,
        itemComments,
      })
      .pipe(takeUntil(this.globalService.componentDestroyed(this)))
      .subscribe(
        (response) => {
          this.isSavingStaffComment = false;
          if (!response?.Status) {
            onFailure();
          }
          if (response?.Status && this.orderDetails?.Items) {
            for (const ic of itemComments) {
              const it = this.orderDetails.Items[ic.index];
              if (it) {
                it.StaffMealComment = ic.comment || null;
              }
            }
            this.globalService.handleSuccessMessage('Item comments saved successfully');
          } else {
            this.globalService.handleApiError(response);
          }
        },
        (error) => {
          this.isSavingStaffComment = false;
          onFailure();
          this.globalService.handleApiError(error);
        }
      );
  }

  private resolveMenuLine(
    order: any,
    menuItemId: any
  ): { itemNameValue: string; categoryName: string } | null {
    const menuSources = [order.ResturantItemName || []];
    if (this.restaurantOrderMode && Array.isArray(order.MenuItem)) {
      menuSources.push(order.MenuItem);
    }

    for (const menuSource of menuSources) {
      for (const menuCategory of menuSource) {
        for (const itemName of menuCategory.ResturantItems || []) {
          if (String(itemName._id) === String(menuItemId)) {
            return {
              itemNameValue:
                itemName.ResturantItemsNameLang?.[0]?.Value || '',
              categoryName:
                menuCategory.ResturantCatogoriesNameLang?.[0]?.Value ||
                'Uncategorized',
            };
          }
        }
      }
    }
    return null;
  }

  private isStrictInclusiveOrder(order: any): boolean {
    const weekKey =
      typeof order?.InclusiveWeekKey === 'string'
        ? order.InclusiveWeekKey.trim()
        : '';
    return (
      order?.IsInclusiveOrder === true &&
      /^\d{4}-\d{2}-\d{2}$/.test(weekKey)
    );
  }

  private buildLineItemsFromOrder(order: any): {
    lines: PeriodicElement[];
    totalRestroTax: number;
    uniqueTaxRates: Set<number>;
  } {
    const lines: PeriodicElement[] = [];
    let totalRestroTax = 0;
    const uniqueTaxRates = new Set<number>();
    const items = order.Items || [];

    for (let itemIndex = 0; itemIndex < items.length; itemIndex++) {
      const id = items[itemIndex];
      const resolved = this.resolveMenuLine(order, id._id);
      if (!resolved && !this.restaurantOrderMode) {
        continue;
      }
      const quantity = id.Quantity;
      const price = id.Price;
      const parsedTaxRate = Number(id.TaxRate?.TaxRate ?? id.TaxRate);
      const taxRate = Number.isFinite(parsedTaxRate) ? parsedTaxRate : 0;
      const itemTax = this.calculateItemTax(price, taxRate) * quantity;
      totalRestroTax += itemTax;
      if (taxRate > 0) {
        uniqueTaxRates.add(taxRate);
      }
      lines.push({
        Itemname: resolved?.itemNameValue || `Item ${itemIndex + 1}`,
        Quantity: Number(quantity),
        Price: Number(price),
        Amount: quantity * price,
        Tax: itemTax,
        itemIndex,
        categoryName: resolved?.categoryName || 'Uncategorized',
        staffMealComment: id.StaffMealComment || '',
      });
    }

    return { lines, totalRestroTax, uniqueTaxRates };
  }

  formatTaxRates(uniqueTaxRates: Set<number>): string {
    const ratesArray = Array.from(uniqueTaxRates).sort((a, b) => a - b);
    
    if (ratesArray.length === 0) {
      return "0%";
    } else if (ratesArray.length === 1) {
      return ` ${ratesArray[0]}%`;
    } else {
      const lastRate = ratesArray.pop();
      return ` ${ratesArray.join('%, ')}% and ${lastRate}%`;
    }
  }


  calculateItemTax(itemPrice: number, taxRate: number): number {
    return (itemPrice * taxRate) / (100 + taxRate);
  }

  fetchRestaurantOrder() {
    this.globalService.showLoader = true; //Set To True

    const decoded = this.jwtService.decodeJwttoken(window.localStorage["CheckIn_TOKEN"]);
    
    let data; 
       if( this.filterDate !== null && this.location =='filter'  ){
        data = {
        BookingUserId: this.BookingUserId?this.BookingUserId:this.UserId,
        HotelId: this.loggedInUserInfo.HotelId,
        Location: 'filter',
        FromDate: this.filterDate.fromDate,
        ToDate: this.filterDate.toDate,
      }
    }else{
        data = {
          BookingUserId: this.BookingUserId?this.BookingUserId:this.UserId,
          HotelId: this.loggedInUserInfo.HotelId,
         Location: 'previous'
      }
    }
    
    this.masterService
      .getRestaurantOrderList(data)
      .pipe(takeUntil(this.globalService.componentDestroyed(this)))
      .subscribe(
        response => {
          if (response.Status) {
            this.RestaurantOrder = response?.Data;
            
            // this.currentCount.emit({data:this.RestaurantOrder.length})
            // this.calculateTotalAmounts();

            let dataSource : Transaction[] = [];


            for (let i = 0; this.RestaurantOrder?.length > i; i++) {
              // ... (existing logic to construct 'data' and 'internalData')
          
              for (let item of this.RestaurantOrder?.[i]?.ResturantItemName) {
                  for (let itemName of item?.ResturantItems) {
                      for (let id of this.RestaurantOrder[i]?.Items) {
                          if (itemName._id === id._id) {
                              const quantity = id.Quantity;
                              const price = id.Price;
                              const itemNameValue = itemName?.ResturantItemsNameLang[0].Value;
          
                              // Construct the transaction data
                              dataSource.push({
                                  item: itemNameValue,
                                  price: Number(price) * Number(quantity),
                              });
                          }
                      }
                  }
              }
          
          }







          //   for(const data of response.Data){
          //   for (const item of data.ResturantItemName) {
          //     for (const itemName of item.ResturantItems) {
          //       for (const id of data.Items) {
          //         
          //         if (itemName._id === id._id) {
          //           const quantity = id.Quantity;
          //           const price = id.Price
          //           const itemNameValue = itemName.ResturantItemsNameLang[0].Value;
          //           
                    
          //           dataSource.push({
          //             item: itemNameValue,
          //             price:Number(price)*Number(quantity),
          //           });
          //         }
          //       }
          //     }
          //   }
          // }
          this.dataSource2 = dataSource.slice(0);

          if(this.filterDate!== null){
            this.location = 'filter'
            }else{
             this.location = 'previous'
            }
            this.globalService.showLoader = false;

          } else {
            
            this.globalService.showLoader = false;
          }

        },
        error => {
          
          
          this.globalService.showLoader = false;
          this.globalService.handleApiError(error);
        }
      );
  }

  filterSet(event){
    this.filterDate = JSON.parse(localStorage.getItem('viewOrderFilterData'));
    if(this.filterDate!== null){
      this.location = 'filter'
      }else{
       this.location = 'previous'
      }

      if(event){
        this.fetchRestaurantOrder();
      }
  }
  selectdDateFilter(event){
    if(event.data == false){
      this.location = 'previous';
      this.fetchRestaurantOrder()

      this.toggle = !this.toggle;
    }else{
     this.filterSet(event)
      this.location = 'filter';
      this.fetchRestaurantOrder()
      this.toggle = !this.toggle;

      
    }
  }
  hideCalendarFilter(): void {
    if(this.filterDate!== null){
      this.location = 'filter'
      }else{
       this.location = 'previous'
      }
    this.toggle = false;
    this.fetchRestaurantOrder();

  }

  OrderHistory(){
    window.localStorage.removeItem('viewOrderFilterData');
  }

 onOrderToggleClick() {
  this.toggleOrders.emit();
  } 

  getTotalCost() {
    return this.transactions.map(t => t.price).reduce((acc, value) => acc + value, 0);
  }

  ngOnDestroy(){

  }
 printInvoice(): void {
 const invoiceData = {
      orderDetails: this.orderDetails,
      currencyLogo: this.currencyLogo,
      currencyAbri: this.currencyAbri,
      dataSource: this.dataSource,
      priceWithoutTax: this.priceWithoutTax,
      tax: this.tax,
      logo: this.logo,
      formattedTaxRates: this.formattedTaxRates,
      Address:this.address
    };
  
    this.dialog.open(RestaurantInvoicePrintComponent, {
      width: '100%',
      panelClass: 'subscription-invoice',
      data: invoiceData
    });
  }
 
  openInvoice(): void {
    const invoiceData = {
      orderDetails: this.orderDetails,
      currencyLogo: this.currencyLogo,
      currencyAbri: this.currencyAbri,
      dataSource: this.dataSource,
      priceWithoutTax: this.priceWithoutTax,
      tax: this.tax,
      logo: this.logo,
      formattedTaxRates: this.formattedTaxRates,
      Address:this.address
    };
  
    this.dialog.open(RestaurantInvoiceComponent, {
      width: '100%',
      panelClass: 'subscription-invoice',
      data: invoiceData
    });
  }
}


export interface PeriodicElement {
  Itemname: string;
  Price: number;
  Quantity: number;
  Amount: number;
  Tax: number;
  itemIndex: number;
  categoryName?: string;
  staffMealComment?: string;
}

// const ELEMENT_DATA: PeriodicElement[] = [
//   {position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H'},
//   {position: 2, name: 'Helium', weight: 4.0026, symbol: 'He'},
//   {position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li'},
//   {position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be'},
// ];

export interface Transaction {
  item: string;
  price: number;
}
const ELEMENT_DATA: PeriodicElement[] = [];
